<script setup lang="ts">
import { ref, onBeforeMount } from 'vue';
import { useI18n } from 'vue-i18n';
import { PACKAGE, HOTEL_ONLY, AIR_ONLY, CRUISE, BOOKING_FORM, PDF_FORM, TOUR, CUSTOMER_FORM, INCENTIVES } from '@/constants';
import { useTermsAndConditionsStore } from '@/store/TermsAndConditionsStore';
import { useToast } from 'primevue/usetoast';
import Tab from 'primevue/tab';
import TabList from 'primevue/tablist';
import TabPanel from 'primevue/tabpanel';
import TabPanels from 'primevue/tabpanels';
import Tabs from 'primevue/tabs';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import TermsAndConditionsTabs from '@/components/termsAndConditions/TermsAndConditionsTabs.vue';

const { t } = useI18n({ useScope: 'global' });
const toast = useToast();
const TermsAndConditionsStore = useTermsAndConditionsStore();
const allTabs = [CUSTOMER_FORM, PDF_FORM, BOOKING_FORM];
const allTypes = [PACKAGE, HOTEL_ONLY, AIR_ONLY, CRUISE, TOUR, INCENTIVES];

const listTermAndConditions = ref<Array<any>>([]);
const isLoading = ref(true);

const handleSubmit = (updatePayload: any) => {
  isLoading.value = true;
  TermsAndConditionsStore.updateData(updatePayload)
    .then(() => {
      toast.add({ severity: 'success', summary: '', detail: t('notification.save_successfully'), life: 3000 });
    })
    .catch(() => {
      toast.add({ severity: 'error', summary: '', detail: t('notification.save_error'), life: 5000 });
    })
    .finally(() => {
      isLoading.value = false;
    });
};

const getTermAndConditionApi = (tab: string, type: string) => {
  let result = {};
  try {
    result = TermsAndConditionsStore.getData(tab, type);
  } catch (error) {
    isLoading.value = false;
    toast.add({ severity: 'error', summary: '', detail: t('notification.unexpected_error'), life: 5000 });
  }
  return result;
};

const fetchAllData = async () => {
  listTermAndConditions.value = [];
  for (const tab of allTabs) {
    const tabResults: any[] = [];
    for (const type of allTypes) {
      if (type === INCENTIVES && tab === CUSTOMER_FORM) {
        continue;
      }
      tabResults.push(await getTermAndConditionApi(tab, type));
    }
    listTermAndConditions.value.push(tabResults);
  }
  isLoading.value = false;
};

const getTabHeader = (tabHeader: string) => {
  switch (tabHeader) {
    case CUSTOMER_FORM:
      return t('common.customer_quote_form');
    case PDF_FORM:
      return 'PDF';
    default:
      return t('common.booking_form');
  }
};

onBeforeMount(async () => {
  await fetchAllData();
});
</script>
<template>
  <div class="card term-conditions">
    <h5>{{ $t('management.term_and_condition') }}</h5>
    <LoadingSpinner v-if="isLoading" />
    <Tabs :value="0">
      <TabList>
        <Tab v-for="(listItem, index) in listTermAndConditions" :key="index" :value="index">{{ getTabHeader(listItem[0].tabType) }}</Tab>
      </TabList>
      <TabPanels>
        <TabPanel v-for="(listItem, index) in listTermAndConditions" :key="index" :value="index">
          <div class="pdf-field">
            <TermsAndConditionsTabs :typeForm="listItem[0].tabType" :listData="listItem" @handleSubmit="(submitData) => handleSubmit(submitData)"></TermsAndConditionsTabs>
          </div>
        </TabPanel>
      </TabPanels>
    </Tabs>
  </div>
</template>
<style lang="scss" scoped>
:deep() {
  .custom-editor {
    .ql-container {
      height: 320px;
    }
  }
}
</style>
